import { baseURL } from 'Types/APITypes';
import { maestroApiCall } from '@michelin/central-provider';

export const getFileUploadURL = () => maestroApiCall({ method: 'POST', endpoint: 'fileUpload', baseURL });

export const getFileDownloadURL = (fileId: string, fileName: string) => maestroApiCall({
  method: 'GET',
  endpoint: 'fileUpload',
  baseURL,
}, { fileId, fileName });

export const getFilePreviewURL = (fileId: string, fileMime: string) => maestroApiCall({
  method: 'GET',
  endpoint: 'fileUpload',
  baseURL,
}, {
  fileId,
  fileMime,
  contentType: fileMime,
  inline: true,
});
